import { Spinner } from 'baseui/spinner'
import PropTypes from 'prop-types'
import { LoaderCard, LoaderContent, LoaderText } from './styled-components'

const SDLoader = ({ text = '', hidden = false }) => {
  if (hidden) return null

  return (
    <LoaderCard>
      <LoaderContent>
        <Spinner size={32} />
        {text && <LoaderText>{text}</LoaderText>}
      </LoaderContent>
    </LoaderCard>
  )
}

SDLoader.propTypes = {
  text: PropTypes.string,
  hidden: PropTypes.bool,
}

export default SDLoader
